export default __webpack_public_path__ + "511efcd8b39f9ebafd83b11de6e97e38.png";